// extracted by mini-css-extract-plugin
export default {"page":"AboutPage_page__9ju+P","lastUpdate":"AboutPage_lastUpdate__A8jgx","section":"AboutPage_section__2ZeHT"};